import { createTheme } from '@material-ui/core/styles'
import { breakpoints } from '../../utils/Breakpoints'

const palette = {
  primary: {
    dark: '#007691',
    main: '#007691',
    light: '#00e0ed',
    contrastText: '#ffffff',
  },
  secondary: {
    dark: '#0d181c',
    main: '#304753',
    light: '#4e7684',
    contrastText: '#ffffff',
  },
  success: {
    main: '#69f0ae',
    dark: '#2bbd7e',
    light: '#9fffe0',
    contrastText: '#000000',
  },
  error: {
    main: '#d32f2f',
    dark: '#c62828',
    light: '#ef5350',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#ed6c02',
    dark: '#e65100',
    light: '#ff9800',
    contrastText: '#ffffff',
  },
}

const hexToRGB = h => {
  let r = 0,
    g = 0,
    b = 0

  // 3 digits
  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]

    // 6 digits
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }
  return { r: +r, g: +g, b: +b }
}

const rgbToRGBA = a => ({ r, g, b }) => {
  return `rgba(${r}, ${g}, ${b}, ${a})`
}

const shadow1 = rgbToRGBA(0.2)
const shadow3 = rgbToRGBA(0.12)
const shadow2 = rgbToRGBA(0.14)

const borderShadow = hex => {
  const rgb = hexToRGB(hex)
  return `inset 0 0 0 1px ${shadow1(rgb)}`
}

const Theme = createTheme({
  breakpoints: {
    values: breakpoints,
  },
  typography: {
    fontFamily: [
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: palette,
  status: {
    danger: 'orange',
  },
  spacing: factor => `${factor * 1}rem`,
  customShadows: {
    primary: {
      light: [
        borderShadow(palette.primary.light),
        `0px 1px 8px 0px ${shadow1(hexToRGB(palette.primary.light))},0px 3px 4px 0px ${shadow2(
          hexToRGB(palette.primary.light)
        )},0px 3px 3px -2px ${shadow3(hexToRGB(palette.primary.light))}`,
      ],
      dark: [
        borderShadow(palette.primary.dark),
        `0px 1px 8px 0px ${shadow1(hexToRGB(palette.primary.dark))},0px 3px 4px 0px ${shadow2(
          hexToRGB(palette.primary.dark)
        )},0px 3px 3px -2px ${shadow3(hexToRGB(palette.primary.dark))}`,
      ],
    },
  },
})

export default Theme
